export const EMBEDDING_DIMENSIONS = 768
export const LLM_TIMEOUT_MS = 60_000
export const DM_REPLY_WINDOW_MS = 24 * 60 * 60 * 1000
export const VIEW_HEARTBEAT_MS = 60 * 1000
export const VIEWER_ACTIVE_WINDOW_MS = 150 * 1000
